/*
* BEM jQuery Plugin
* Provides BEM naming convention utilities for jQuery elements
*/

(function($) {
  // Get BEM block name from element
  function getBlockName(el) {
    let classes = el.attr('class')
    if (!classes) return ''
    return classes.split(' ')[0].split('--')[0].split('__')[0]
  }

  // Create a BEM element
  $.fn.addElement = function(elementName) {
    let blockName = getBlockName(this)
    let $el = $('<div></div>').addClass(blockName + '__' + elementName)
    return $el
  }

  // Add a BEM modifier
  $.fn.addModifier = function(modifierName) {
    let blockName = getBlockName(this)
    this.addClass(blockName + '--' + modifierName)
    return this
  }

  // Remove a BEM modifier
  $.fn.removeModifier = function(modifierName) {
    let blockName = getBlockName(this)
    this.removeClass(blockName + '--' + modifierName)
    return this
  }

  // Create a BEM block element
  $.fn.BlockElement = function(blockName) {
    this.addClass(blockName)
    return this
  }
})(jQuery)
